import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { colors } from 'parameters/ui'
import { SkeletonStyle } from 'components/patterns/Skeleton/blocks/styles'

export const VariableDeclarations = css`
	--wide-image-width: 66%;
	--card-body-padding: 20px;
	--card-body-min-height: inherit;
`

export const GenericArticleCard = css`
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	background-color: ${colors.white};
	position: relative;
	transition: 0.3s;
	cursor: pointer;
	display: flex;
	flex-direction: column;

	&:hover {
		transform: translateY(-5px);
	}
`

export const CardBody = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	flex: 2 0 auto;
	padding: var(--card-body-padding, 20px);
	min-height: 198px;
`

interface LineCountProps {
	lineCount: number
	lineHeight: number
}

/**
 * This only works for modern browsers, but max height will still cut off IE
 * @param props
 * @constructor
 */
const ParagraphWrapByLines = (props: LineCountProps) => css`
	-webkit-box-orient: vertical;
	display: -webkit-box;
	-webkit-line-clamp: ${props.lineCount};
	text-overflow: ellipsis;
	overflow: hidden;
	line-height: ${props.lineHeight};
	max-height: calc(${props.lineCount} * ${props.lineHeight}em);
`

export const ImageContainer = styled.div`
	overflow: hidden;
	border-radius: 8px 8px 0 0;
	background: ${colors.primaryLightGrey1};
	display: flex;
	position: relative;
	flex: 1 1 50%;
`

export const CardTitle = styled.span<LineCountProps>`
	font-size: 20px;
	font-weight: 700;
	text-decoration: none;
	letter-spacing: normal;
	margin-bottom: 8px;
	color: #0d0808;
	:hover {
		color: initial;
	}
	${ParagraphWrapByLines};
`

export const CardText = styled.p<LineCountProps>`
	color: #0d0808;
	${ParagraphWrapByLines};
	display: none;
`

export const CardBottom = styled.div`
	width: 100%;
	flex: 1 0 auto;
	line-height: 1;
	margin-top: 10px;
	align-items: flex-end;
	display: flex;
	align-self: flex-end;
	justify-content: space-between;
`

export const CardBottomText = styled.div`
	color: ${colors.secondaryDarkGrey1};
	display: flex;
	height: 1em;
	overflow: hidden;
`

export const Topic = styled.span`
	display: block;
	color: ${colors.secondaryDarkGrey1};
	margin-bottom: 8px;
`

export const SkeletonImage = styled(SkeletonStyle)`
	display: block;
	border-radius: 0;
`
